export default __webpack_public_path__ + "static/media/tzuyu3.6bdd9c91.jpg";